export enum SlideDirection {
  FromLeft = 'FromLeft',
  FromRight = 'FromRight',
  FromTop = 'FromTop',
  FromBottom = 'FromBottom',
}
